import $Notice from './notice';
var Notice = new $Notice();
export default Notice;
